module.exports = __webpack_public_path__ + "img/rob-635e276.jpg";